module.exports = __webpack_public_path__ + "img/eat_notes.931abcd6.png";